export default __webpack_public_path__ + "static/media/bodds-logo.705902d7.png";